<template>
  <svg :width="width" :height="height" viewBox="0 0 25 27" fill xmlns="http://www.w3.org/2000/svg">
    <g :fill="color">
      <path d="M2.62891 20.9336L11.8516 26.1602C12.5078 26.5352 13.1289 26.5352 13.7969 26.1602L23.0078 20.9336C24.0859 20.3242 24.6484 19.7031 24.6484 18.0273V8.74609C24.6484 7.52734 24.2031 6.76562 23.2188 6.20312L14.9219 1.49219C13.5039 0.671875 12.1328 0.671875 10.7148 1.49219L2.42969 6.20312C1.43359 6.76562 0.988281 7.52734 0.988281 8.74609V18.0273C0.988281 19.7031 1.5625 20.3242 2.62891 20.9336ZM12.8242 12.6953L3.77734 7.57422L11.5 3.16797C12.4023 2.65234 13.2344 2.64062 14.1484 3.16797L21.8711 7.57422L12.8242 12.6953ZM3.68359 19.3867C3.00391 19.0117 2.76953 18.6133 2.76953 17.9688V9.12109L11.8984 14.3359V24.0625L3.68359 19.3867ZM21.9648 19.3867L13.7383 24.0625V14.3359L22.8672 9.12109V17.9688C22.8672 18.6133 22.6328 19.0117 21.9648 19.3867Z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>
